import { BuildStatus } from '../../../types'
import type { BadgeColor } from '../../Badge/Badge.types'

export function getBuildStatusBadgeColor(status: BuildStatus): BadgeColor {
  switch (status) {
    case BuildStatus.Idle:
      return 'grey'
    case BuildStatus.New:
      return 'blue'
    case BuildStatus.Queued:
      return 'amber'
    case BuildStatus.Running:
      return 'green'
    case BuildStatus.Stopped:
      return 'red'
  }
}
